import Vuex, { Store } from "vuex";

export const createStore: () => Store<any> = () => new Vuex.Store({});
